import { useMemo } from "react";
import { useUser } from "@clerk/clerk-react";
import { ownerFromEmail } from "../lib/owner";

function getPrimaryEmail(user: ReturnType<typeof useUser>["user"]): string | null {
  if (!user) return null;
  return user.primaryEmailAddress?.emailAddress ?? user.emailAddresses[0]?.emailAddress ?? null;
}

export function useCurrentOwner() {
  const { user, isLoaded } = useUser();

  return useMemo(() => {
    const email = getPrimaryEmail(user);
    const owner = ownerFromEmail(email);
    return { email, owner, isLoaded };
  }, [user, isLoaded]);
}
